import { Context } from '../../../common'
import { Api, HttpClient, IdentityCardsApi } from '../../../api'
import {
  ConfirmableDataForIdentityCard,
  IdentityCard,
  IdentityCardsService,
  PrintableDataForIdentityCard,
} from './identityCards'

function mapDtoToIdentityCard(dto: Api.IdentityCard): IdentityCard {
  return {
    ...dto,
    id: dto.id,
    createdAt: new Date(dto.createdAt),
    confirmedAt: dto.confirmedAt ? new Date(dto.confirmedAt) : undefined,
  }
}

export class RemoteIdentityCardsService implements IdentityCardsService {
  private api: IdentityCardsApi

  constructor(httpClient: HttpClient) {
    this.api = new IdentityCardsApi(httpClient, undefined, '')
  }

  async findCitizenCards(ctx: Context, citizenId: string): Promise<IdentityCard[]> {
    const result = await this.api.identityCardsGetListByCitizenId(ctx, citizenId)

    return result.body.items.map(mapDtoToIdentityCard)
  }

  async confirm(ctx: Context, card: ConfirmableDataForIdentityCard): Promise<IdentityCard> {
    const result = await this.api.identityCardsConfirm(ctx, card)

    return mapDtoToIdentityCard(result.body.object)
  }

  async print(ctx: Context, card: PrintableDataForIdentityCard): Promise<IdentityCard> {
    const result = await this.api.identityCardsPrint(ctx, card)

    return mapDtoToIdentityCard(result.body.object)
  }
}
